export const PERIOD_OPTIONS = ['MTD', 'L30', 'L60', 'YTD', 'L12M', 'Custom'] as const;
